import { PRODUCT_CONFIGURATOR_RECEIVE } from '../Actions/ProductConfigurator.action';

export const articles = (state = {articles : [], emptyArticles : []}, action) => {
    switch (action.type) {
        case PRODUCT_CONFIGURATOR_RECEIVE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}